export const currencyFormater = Intl.NumberFormat('en-US', {
	style: 'decimal',
	maximumFractionDigits: 2,
	minimumFractionDigits: 2,
})

/**
 * Money with its currency symbol, matching how the candidate portal renders
 * pay so a provider comparing the two portals sees the same figure written the
 * same way.
 *
 * Falls back to the plain decimal format rather than throwing on a currency
 * code the runtime does not know — a pay figure that renders slightly wrong is
 * recoverable, one that crashes the earnings screen is not.
 */
export const formatCurrency = (amount, currency = 'USD') => {
	const value = Number(amount)
	if (!Number.isFinite(value)) return null

	try {
		return Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: currency || 'USD',
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		}).format(value)
	} catch (error) {
		return currencyFormater.format(value)
	}
}
